import history from '../../util/history'

const toEditView = id => {
  history.push(`/segment_settings/${id}/edit`)

  return true
}

export default toEditView
